// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--color-bg-white);
  border-top: 1px solid #e5e7eb;
  z-index: 1000;
  display: none;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}

.nav-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  max-width: 100%;
  gap: 8px;
}

.nav-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 20px;
  padding: 8px 16px;
  border: 1px solid transparent;
  background: transparent;
  flex: 1 1;
  max-width: 160px;
  gap: 6px;
  text-decoration: none;
}

.nav-item:hover {
  background: rgba(108, 92, 231, 0.1);
  border-color: rgba(108, 92, 231, 0.3);
}

.nav-item-active {
  background: var(--color-primary);
  border-color: var(--color-primary);
  color: white;
}

.nav-item-active .nav-icon {
  color: white;
}

.nav-item-active .nav-label {
  color: white;
}

.nav-icon {
  font-size: 16px;
  color: #6b7280;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.nav-label {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
  transition: all 0.3s ease;
  white-space: nowrap;
}

/* 只在PAD端显示移动端导航，Mobile端隐藏 */
@media (max-width: 768px) and (min-width: 481px) {
  .mobile-bottom-nav {
    display: block;
  }
}

/* Mobile端隐藏底部导航 */
@media (max-width: 480px) {
  .mobile-bottom-nav {
    display: none;
  }
}

@media (max-width: 480px) {
  .nav-container {
    padding: 10px 12px calc(10px + env(safe-area-inset-bottom));
    gap: 6px;
  }

  .nav-item {
    padding: 6px 12px;
    max-width: 100px;
    gap: 4px;
  }

  .nav-icon {
    font-size: 14px;
  }

  .nav-label {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/MobileBottomNav.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iCAAiC;EACjC,6BAA6B;EAC7B,aAAa;EACb,aAAa;EACb,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,2DAA2D;EAC3D,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,uBAAuB;EACvB,SAAO;EACP,gBAAgB;EAChB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE;IACE,cAAc;EAChB;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,2DAA2D;IAC3D,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".mobile-bottom-nav {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: var(--color-bg-white);\n  border-top: 1px solid #e5e7eb;\n  z-index: 1000;\n  display: none;\n  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);\n  flex-shrink: 0;\n}\n\n.nav-container {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));\n  max-width: 100%;\n  gap: 8px;\n}\n\n.nav-item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border-radius: 20px;\n  padding: 8px 16px;\n  border: 1px solid transparent;\n  background: transparent;\n  flex: 1;\n  max-width: 160px;\n  gap: 6px;\n  text-decoration: none;\n}\n\n.nav-item:hover {\n  background: rgba(108, 92, 231, 0.1);\n  border-color: rgba(108, 92, 231, 0.3);\n}\n\n.nav-item-active {\n  background: var(--color-primary);\n  border-color: var(--color-primary);\n  color: white;\n}\n\n.nav-item-active .nav-icon {\n  color: white;\n}\n\n.nav-item-active .nav-label {\n  color: white;\n}\n\n.nav-icon {\n  font-size: 16px;\n  color: #6b7280;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n}\n\n.nav-label {\n  font-size: 14px;\n  color: #6b7280;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n/* 只在PAD端显示移动端导航，Mobile端隐藏 */\n@media (max-width: 768px) and (min-width: 481px) {\n  .mobile-bottom-nav {\n    display: block;\n  }\n}\n\n/* Mobile端隐藏底部导航 */\n@media (max-width: 480px) {\n  .mobile-bottom-nav {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .nav-container {\n    padding: 10px 12px calc(10px + env(safe-area-inset-bottom));\n    gap: 6px;\n  }\n\n  .nav-item {\n    padding: 6px 12px;\n    max-width: 100px;\n    gap: 4px;\n  }\n\n  .nav-icon {\n    font-size: 14px;\n  }\n\n  .nav-label {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
